var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    gradientUnits: "userSpaceOnUse",
    x1: 1047.862,
    y1: -483.626,
    x2: 1048.862,
    y2: -483.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    gradientUnits: "userSpaceOnUse",
    x1: 91.88,
    y1: 118.953,
    x2: 126.382,
    y2: 118.953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M93.13 118.953h32.002"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    gradientUnits: "userSpaceOnUse",
    x1: 85.773,
    y1: 35.158,
    x2: 112.946,
    y2: 35.158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M87.023 35.158h24.673"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M69.188 51.526h55.944M69.188 58.122h55.944M69.188 64.718h55.944M69.188 71.314h55.944M69.188 77.666h27.85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M139.191 108.142v25.813h-83.44V44.464M78.555 21.66h60.636v50.448"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M78.558 21.66L55.755 44.463h22.803zM149.536 78.67l16.879 12.959M143.134 74.654c-.974-1.329-2.828-2.073-4.622-2.064l-13.306 7.083c-2.733 1.676-3.37 2.233-4.91 5.104l-6.519 12.501c.011 2.33.72 4.169 2.702 4.535M141.772 97.704l.002-3.23-4.541-3.442"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M123.03 104.872l-5.954 6.013-7.797 3.242 2.96-8.033 37.295-37.65 5.237 4.387-24.483 24.717"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M141.739 97.771l-13.858.066a4.955 4.955 0 00.047 9.909l19.917-.095"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M147.732 107.64s3.244.409 6.435-3.405l3.464 2.123M156.725 108.889l12.188-18.757 7.41 4.816-12.189 18.756z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.b1cafe46a2f1a9170a342252257192d1.svg";
export { ForwardRef as ReactComponent };